export default __webpack_public_path__ + "static/HeroSteel-d2ddf41d7578b8f9fbbd7bf7f3a17591.jpg";